//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Autocomplete from 'vue2-autocomplete-js';
import UMUM from  '../../library/umum.js'
import WILAYAH from  '../../library/getWilayah'
import uniqid from 'uniqid'; 
import MASTER_MENU from  '../../library/master_menu'
import FETCHING from  '../../library/fetching'

export default {
    data () {
        return {
          FETCHING:FETCHING,
          token : localStorage.token,
          MASTER_MENU:MASTER_MENU, 
          UMUM:UMUM, 
          dense:true,
          add_keluarga:false,
          modal_hapus_keluarga:false,
          modal_edit_anggota_keluarga:false,
            terbitkanSurat  :false,
            modal_y:false,
            modal_n:false,

            lihat_blue:false,
            lihat_red:false,   

            modul:'PPD3',

            current:3,
             
             
             
          page_limit   : 10,
          page_first   : 1,
          page_last    : 0,
          cari_value   : "",

          list_kepindahan:[ {uraian:'Pekerjaan'},{uraian:'Pendidikan'},{uraian:'Keamanan'},{uraian:'Kesehatan'},{uraian:'Perumahan'},{uraian:'Keluarga'},{uraian:'Lainnya'} ],
          list_jenis_kepindahan:[ {uraian:'Kep. Keluarga'},{uraian:'Kep. Keluarga dan Seluruh Angg. Keluarga '},{uraian:'Kep. Keluarga dan Sbg. Angg. Keluarga'},{uraian:'Angg. Keluarga'}, ],
          list_status_kk_bagi_yang_tidak_pindah:[ {uraian:'Numpang KK'},{uraian:'Membuat KK Baru'},{uraian:'Nomor KK Tetap'} ],
          list_status_kk_bagi_yang_pindah:[ {uraian:'Numpang KK'},{uraian:'Membuat KK Baru'},{uraian:'Nomor KK Tetap'} ],

          option_status : [{id  : 0, uraian : 'Proses'}, {id  : 1, uraian : 'Diterima'}, {id  : 2, uraian : 'Dikembalikan'}],

          list_data : [],
          list_anggota_keluarga : [],
          list_data_kecamatan : [],
          list_data_kabupaten : [],
          form: {
              id : '',
              KKref : '',
              id_dari_form : '',

              m_provinsi : '74',
              m_kabupaten : '7405',
              m_kecamatan : '',
              m_desa_kelurahan : '', 

              no_kk                :'',
              nama_kepalaKeluarga  :'',
              alamat               :'',
              rt                   :'',
              rw                   :'',
              provinsi             :'',
              kabupaten            :'',
              kecamatan            :'',  
              desa_kelurahan       :'',
              kode_pos             :'',
              no_telp              :'', 

              nik                  :'',
              nama                 :'',

              alasan_kepindahan         :'',
              alasan_kepindahan_lainnya :'',

              alamat_tujuan         : '',
              rt_tujuan             : '',
              rw_tujuan             : '',
              provinsi_tujuan       :'',
              kabupaten_tujuan      :'',
              kecamatan_tujuan      :'',  
              desa_kelurahan_tujuan :'',
              kodePos_tujuan        :'',
              noTelp_tujuan         :'',


              jenis_kepindahan:'',
              status_kk_bagi_yang_tidak_pindah:'',
              status_kk_bagi_yang_pindah:'',

              shdk:'',
              shdk_lainnya:'', 

              file_lampiran     :null,
              file_lampiranOld  :null,

              file_Kabupaten:null,
              file_Old_Kabupaten:null,

                status : 0,
                keterangan : 0,
                
                keterangan_deskel:'',
                keterangan_kecamatan:'',
                keterangan_kabupaten  :'',

                status_deskel:0,
                status_kecamatan:0,
                status_kabupaten  :0,

                createdBy : '',
                createdAt : '',
                createdAt_deskel:'',
                createdAt_kecamatan:'',
                createdAt_kabupaten  :'',

              file_terbitan   : null,
              emailPemohon    : '',
              email_file      : null,
              email_fileOld   : '',
              email_from      : '',
              email_to        : '',
              email_subject   : '',
              email_html      : '',
          },   
          anggota_keluarga: {
              nik : '',
              nama : '',
              tglKTP_dari : '',
              tglKTP_hingga : '', 

              shdk:'',
              shdk_lainnya:'',

          },
          wilayah : {
            uraian_provinsi : '',
            kd_provinsi : '',
            uraian_kabupaten : '',
            kd_kabupaten : '',
            uraian_kecamatan : '',
            kd_kecamatan : '',
            uraian_desa_kelurahan : '',
            kd_desa_kelurahan : '',
          },
          wilayah_pemohon : {
            uraian_provinsi : '',
            kd_provinsi : '',
            uraian_kabupaten : '',
            kd_kabupaten : '',
            uraian_kecamatan : '',
            kd_kecamatan : '',
            uraian_desa_kelurahan : '',
            kd_desa_kelurahan : '',
          },
          wilayah_tujuan : {
            uraian_provinsi : '',
            kd_provinsi : '',
            uraian_kabupaten : '',
            kd_kabupaten : '',
            uraian_kecamatan : '',
            kd_kecamatan : '',
            uraian_desa_kelurahan : '',
            kd_desa_kelurahan : '',
          },
        }
    },
    methods: {
       addAnggotaKeluarga:function(){
        var arr = this.list_anggota_keluarga; 
        arr.push(this.anggota_keluarga);
        
        this.anggota_keluarga = {
          nik             :'',
          nama            :'',
          tglKTP_dari     :'',
          tglKTP_hingga   :'',
          shdk            :'',
          shdk_lainnya    :'',
        }
      },
      delete_keluarga : function (index){  
        this.list_anggota_keluarga.splice(index, 1);  
        this.$store.commit('notif_berhasil_menghapus');        
      },
      select_keluarga(data, index){

        // console.log(data, index) 
        this.id = data._id
        this.index_ke = index 
      },
      delete_keluarga2(data, index){
        this.$store.state.modal_loading = true;

        console.log(this.index_ke) 
        fetch(this.$store.state.url.URL_PERMOHONAN_PPD3 + "hapus_keluarga", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id : this.id,
                fileOld : this.fileOld,
            })
        }).then(res_data => {
            this.list_anggota_keluarga.splice(this.index_ke, 1); 
          this.$store.state.modal_loading = false;

            this.modal_hapus_keluarga = false
            this.$store.commit('notif_berhasil_menghapus'); 
            this.getView();
        });
      },
      EditAnggotaKeluarga(){
        this.$store.state.modal_loading = true;

          var a = this.form.KKref  
          this.anggota_keluarga.KKref = a 
          console.log('aaaaa = ', a);

          var formData = new FormData(); 
          formData.append("biodata", JSON.stringify(this.anggota_keluarga));

          fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNI + "editData_AK", {
              method: "POST",
              headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: formData
          }).then(res_data => { 
            this.$store.state.modal_loading = false;

              this.$store.commit('notif_edit');
              var arr = this.list_anggota_keluarga; 
              arr.push(this.anggota_keluarga);
              
              this.anggota_keluarga = {
                nik : '',
                nama : '',
                tanggal_lahir : '',
                jenis_kelamin : '',
                shdk:'',
                shdk_lainnya:'',
                agama : '',
                agama_lainnya : '',
                pekerjaan : '',
                pekerjaan_lainnya : '',
                pendidikan : '',
                pendidikan_lainnya : '',
              }

              this.getView();
          }); 
      },

      getView : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PERMOHONAN_PPD3 + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                createdBy : this.$store.state.lcProfile.id
            })
          })
            .then(res => res.json())
            .then(res_data => { 
                this.list_data = res_data.data;  
                this.page_last = res_data.jmlData;   
                console.log(res_data.data);
        });
      },

      validateForm: function() {
        const f = this.form;

        // ========== WILAYAH ADMINISTRASI TUJUAN SISTEM ==========
        if (!f.m_provinsi || f.m_provinsi === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih provinsi wilayah administrasi.' });
          return false;
        }
        if (!f.m_kabupaten || f.m_kabupaten === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kabupaten wilayah administrasi.' });
          return false;
        }
        if (!f.m_kecamatan || f.m_kecamatan === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kecamatan wilayah administrasi.' });
          return false;
        }
        if (!f.m_desa_kelurahan || f.m_desa_kelurahan === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih desa/kelurahan wilayah administrasi.' });
          return false;
        }

        // ========== DATA DAERAH ASAL ==========
        if (!f.no_kk || f.no_kk.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nomor kartu keluarga wajib diisi.' });
          return false;
        }
        if (!f.nama_kepalaKeluarga || f.nama_kepalaKeluarga.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nama kepala keluarga daerah asal wajib diisi.' });
          return false;
        }
        if (!f.alamat || f.alamat.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Alamat daerah asal wajib diisi.' });
          return false;
        }
        if (f.rt === '' || f.rt === null || f.rt === undefined) {
          this.$q.notify({ type: 'negative', message: 'RT daerah asal wajib diisi.' });
          return false;
        }
        if (f.rw === '' || f.rw === null || f.rw === undefined) {
          this.$q.notify({ type: 'negative', message: 'RW daerah asal wajib diisi.' });
          return false;
        }
        if (!f.provinsi || f.provinsi === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih provinsi daerah asal.' });
          return false;
        }
        if (!f.kabupaten || f.kabupaten === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kabupaten daerah asal.' });
          return false;
        }
        if (!f.kecamatan || f.kecamatan === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kecamatan daerah asal.' });
          return false;
        }
        if (!f.desa_kelurahan || f.desa_kelurahan === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih desa/kelurahan daerah asal.' });
          return false;
        }
        if (!f.kode_pos || f.kode_pos.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Kode pos daerah asal wajib diisi.' });
          return false;
        }
        if (!f.no_telp || f.no_telp.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nomor telepon daerah asal wajib diisi.' });
          return false;
        }
        if (!f.nik || f.nik.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'NIK pemohon wajib diisi.' });
          return false;
        }
        if (!f.nama || f.nama.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nama lengkap pemohon wajib diisi.' });
          return false;
        }

        // ========== DATA KEPINDAHAN ==========
        if (!f.alasan_kepindahan || f.alasan_kepindahan === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih alasan kepindahan.' });
          return false;
        }
        if (f.alasan_kepindahan === 'Lainnya' && (!f.alasan_kepindahan_lainnya || f.alasan_kepindahan_lainnya.trim() === '')) {
          this.$q.notify({ type: 'negative', message: 'Isi alasan kepindahan lainnya.' });
          return false;
        }
        if (!f.alamat_tujuan || f.alamat_tujuan.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Alamat tujuan pindah wajib diisi.' });
          return false;
        }
        if (f.rt_tujuan === '' || f.rt_tujuan === null || f.rt_tujuan === undefined) {
          this.$q.notify({ type: 'negative', message: 'RT tujuan pindah wajib diisi.' });
          return false;
        }
        if (f.rw_tujuan === '' || f.rw_tujuan === null || f.rw_tujuan === undefined) {
          this.$q.notify({ type: 'negative', message: 'RW tujuan pindah wajib diisi.' });
          return false;
        }
        if (!f.provinsi_tujuan || f.provinsi_tujuan === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih provinsi tujuan pindah.' });
          return false;
        }
        if (!f.kabupaten_tujuan || f.kabupaten_tujuan === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kabupaten tujuan pindah.' });
          return false;
        }
        if (!f.kecamatan_tujuan || f.kecamatan_tujuan === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kecamatan tujuan pindah.' });
          return false;
        }
        if (!f.desa_kelurahan_tujuan || f.desa_kelurahan_tujuan === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih desa/kelurahan tujuan pindah.' });
          return false;
        }
        if (!f.kodePos_tujuan || f.kodePos_tujuan.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Kode pos tujuan pindah wajib diisi.' });
          return false;
        }
        if (!f.noTelp_tujuan || f.noTelp_tujuan.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nomor telepon tujuan pindah wajib diisi.' });
          return false;
        }
        if (!f.jenis_kepindahan || f.jenis_kepindahan === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih jenis kepindahan.' });
          return false;
        }
        if (!f.status_kk_bagi_yang_tidak_pindah || f.status_kk_bagi_yang_tidak_pindah === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih status KK bagi yang tidak pindah.' });
          return false;
        }
        if (!f.status_kk_bagi_yang_pindah || f.status_kk_bagi_yang_pindah === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih status KK bagi yang pindah.' });
          return false;
        }

        // ========== LAMPIRAN FILE ==========
        if (!f.file_lampiran || f.file_lampiran === '') {
          this.$q.notify({ type: 'negative', message: 'File lampiran wajib diisi.' });
          return false;
        }

        return true;
      },
      addData:function(){
        // Jalankan validasi sebelum submit
        if (!this.validateForm()) {
          return;
        }

        this.$store.state.modal_loading = true;

          console.log(this.form);
          var formData = new FormData();

          formData.append("data", JSON.stringify(this.form));
          formData.append("biodata", JSON.stringify(this.list_anggota_keluarga)); 
          formData.append("file_lampiran",  this.form.file_lampiran); 
          

            fetch(this.$store.state.url.URL_PERMOHONAN_PPD3 + "addData", {
                method: "POST",
                headers: {
                    // "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: formData
            }).then(res_data => { 
          this.$store.state.modal_loading = false;

                this.$store.commit('notif_berhasil')
                this.getView();
            });
      },
      editData:function(){
        this.$store.state.modal_loading = true;

        // console.log('ini form = ', this.form);
        // console.log('ini list = ', this.list_anggota_keluarga);
        // URL_PERMOHONAN_PPD3
        var formData = new FormData();
        formData.append("data", JSON.stringify(this.form));
        formData.append("biodata", JSON.stringify(this.list_anggota_keluarga));
        formData.append("file_lampiran",  this.form.file_lampiran); 
        fetch(this.$store.state.url.URL_PERMOHONAN_PPD3 + "editData", {
            method: "POST",
            headers: {
              // "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            // console.log(res_data); 
          this.$store.state.modal_loading = false;

            this.$store.commit('notif_edit');
            this.getView();
        });

      }, 
      removeData:function(){ 
        this.$store.state.modal_loading = true;
        fetch(this.$store.state.url.URL_PERMOHONAN_PPD3 + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id                  : this.form.id,
                KKref               : this.form.KKref,
                fileOld             : this.fileOld,
                file_lampiran      : this.form.file_lampiran,
                file_lampiranOld  : this.form.file_lampiranOld,
            })
        }).then(res_data => {
            this.$store.state.modal_loading = false;
            this.$store.commit('notif_berhasil_menghapus');
            this.getView();
        });     
      }, 
      selectData:function(data){
        console.log(data);
        
        this.form.id                                 = data.PPD3.id
        this.form.KKref                              = data.PPD3.KKref
        this.form.id_dari_form                       = data.PPD3.id_dari_form
        this.form.m_provinsi                         = data.PPD3.m_provinsi
        this.form.m_kabupaten                        = data.PPD3.m_kabupaten
        this.form.m_kecamatan                        = data.PPD3.m_kecamatan
        this.form.m_desa_kelurahan                   = data.PPD3.m_desa_kelurahan
        this.form.no_kk                              = data.PPD3.no_kk
        this.form.nama_kepalaKeluarga                = data.PPD3.nama_kepalaKeluarga
        this.form.alamat                             = data.PPD3.alamat
        this.form.rt                                 = data.PPD3.rt
        this.form.rw                                 = data.PPD3.rw

        this.form.provinsi                           = data.PPD3.provinsi
        this.form.kabupaten                          = data.PPD3.kabupaten
        this.form.kecamatan                          = data.PPD3.kecamatan
        this.form.desa_kelurahan                     = data.PPD3.desa_kelurahan

        this.form.kode_pos                           = data.PPD3.kode_pos
        this.form.no_telp                            = data.PPD3.no_telp
        this.form.nik                                = data.PPD3.nik
        this.form.nama                               = data.PPD3.nama
        this.form.alasan_kepindahan                  = data.PPD3.alasan_kepindahan
        this.form.alasan_kepindahan_lainnya          = data.PPD3.alasan_kepindahan_lainnya
        this.form.alamat_tujuan                      = data.PPD3.alamat_tujuan
        this.form.rt_tujuan                          = data.PPD3.rt_tujuan
        this.form.rw_tujuan                          = data.PPD3.rw_tujuan

        this.form.provinsi_tujuan                    = data.PPD3.provinsi_tujuan
        this.form.kabupaten_tujuan                   = data.PPD3.kabupaten_tujuan
        this.form.kecamatan_tujuan                   = data.PPD3.kecamatan_tujuan
        this.form.desa_kelurahan_tujuan              = data.PPD3.desa_kelurahan_tujuan
        
        this.form.kodePos_tujuan                     = data.PPD3.kodePos_tujuan
        this.form.noTelp_tujuan                      = data.PPD3.noTelp_tujuan
        this.form.jenis_kepindahan                   = data.PPD3.jenis_kepindahan
        this.form.status_kk_bagi_yang_tidak_pindah   = data.PPD3.status_kk_bagi_yang_tidak_pindah
        this.form.status_kk_bagi_yang_pindah         = data.PPD3.status_kk_bagi_yang_pindah
        this.form.shdk                               = data.PPD3.shdk
        this.form.shdk_lainnya                       = data.PPD3.shdk_lainnya
        this.form.file_Kabupaten                     = data.PPD3.file_Kabupaten
        this.form.file_Old_Kabupaten                 = data.PPD3.file_Old_Kabupaten
        

        this.form.file_lampiran                     = data.PPD3.file_lampiran
        this.form.file_lampiranOld                  = data.PPD3.file_lampiranOld


        this.form.status                            = data.PPD3.status
        this.form.keterangan                        = data.PPD3.keterangan
        this.form.keterangan_deskel                 = data.PPD3.keterangan_deskel
        this.form.keterangan_kecamatan              = data.PPD3.keterangan_kecamatan
        this.form.keterangan_kabupaten              = data.PPD3.keterangan_kabupaten
        this.form.status_deskel                     = data.PPD3.status_deskel
        this.form.status_kecamatan                  = data.PPD3.status_kecamatan
        this.form.status_kabupaten                  = data.PPD3.status_kabupaten
        this.form.createdBy                         = data.PPD3.createdBy
        this.form.createdAt                         = data.PPD3.createdAt
        this.form.createdAt_deskel                  = data.PPD3.createdAt_deskel
        this.form.createdAt_kecamatan               = data.PPD3.createdAt_kecamatan
        this.form.createdAt_kabupaten               = data.PPD3.createdAt_kabupaten


        this.list_anggota_keluarga = data.databio

        this.form.emailPemohon          = data.PPD3.emailPemohon;
        this.form.email_fileOld         = data.PPD3.email_file;
        this.form.email_from            = this.form.email_from;
        this.form.email_to              = this.form.emailPemohon;
        this.form.email_subject         = data.PPD3.email_subject;
        if (data.PPD3.email_html == undefined || data.PPD3.email_html == null || data.PPD3.email_html == '') {
          this.form.email_html          = ''
        } else {
          this.form.email_html          = data.PPD3.email_html; 
        }

        this.wilayah = {
          uraian_provinsi       : data.m_provinsi.uraian,
          kd_provinsi           : data.m_provinsi.kd_provinsi,
          uraian_kabupaten      : data.m_kabupaten.uraian,
          kd_kabupaten          : data.m_kabupaten.kd_kabupaten,
          uraian_kecamatan      : data.m_kecamatan.uraian,
          kd_kecamatan          : data.m_kecamatan.kd_kecamatan,
          uraian_desa_kelurahan : data.m_desa_kelurahan.uraian,
          kd_desa_kelurahan     : data.m_desa_kelurahan.kd_desa_kelurahan,
        }
 
        this.wilayah_pemohon = {
          uraian_provinsi       : data.provinsi.uraian,
          kd_provinsi           : data.provinsi.kd_provinsi,
          uraian_kabupaten      : data.kabupaten.uraian,
          kd_kabupaten          : data.kabupaten.kd_kabupaten,
          uraian_kecamatan      : data.kecamatan.uraian,
          kd_kecamatan          : data.kecamatan.kd_kecamatan,
          uraian_desa_kelurahan : data.desa_kelurahan.uraian,
          kd_desa_kelurahan     : data.desa_kelurahan.kd_desa_kelurahan,
        }
        this.wilayah_tujuan = {
          uraian_provinsi       : data.provinsi_tujuan.uraian,
          kd_provinsi           : data.provinsi_tujuan.kd_provinsi,
          uraian_kabupaten      : data.kabupaten_tujuan.uraian,
          kd_kabupaten          : data.kabupaten_tujuan.kd_kabupaten,
          uraian_kecamatan      : data.kecamatan_tujuan.uraian,
          kd_kecamatan          : data.kecamatan_tujuan.kd_kecamatan,
          uraian_desa_kelurahan : data.desa_kelurahan_tujuan.uraian,
          kd_desa_kelurahan     : data.desa_kelurahan_tujuan.kd_desa_kelurahan,
        }
      },
      
      clear_data:function(data){

              this.list_anggota_keluarga                  = []
              this.form.id                                = ''
              this.form.KKref                             = ''
              this.form.id_dari_form                      = ''
              this.form.m_provinsi                        = '74'
              this.form.m_kabupaten                       = '7405'
              this.form.m_kecamatan                       = ''
              this.form.m_desa_kelurahan                  = ''
              this.form.no_kk                             = ''
              this.form.nama_kepalaKeluarga               = ''
              this.form.alamat                            = ''
              this.form.rt                                = ''
              this.form.rw                                = ''
              this.form.provinsi                          = ''
              this.form.kabupaten                         = ''
              this.form.kecamatan                         = ''
              this.form.desa_kelurahan                    = ''
              this.form.kode_pos                          = ''
              this.form.no_telp                           = ''
              this.form.nik                               = ''
              this.form.nama                              = ''
              this.form.alasan_kepindahan                 = ''
              this.form.alasan_kepindahan_lainnya         = ''
              this.form.alamat_tujuan                     = ''
              this.form.rt_tujuan                         = ''
              this.form.rw_tujuan                         = ''
              this.form.provinsi_tujuan                   = ''
              this.form.kabupaten_tujuan                  = ''
              this.form.kecamatan_tujuan                  = ''
              this.form.desa_kelurahan_tujuan             = ''
              this.form.kodePos_tujuan                    = ''
              this.form.noTelp_tujuan                     = ''
              this.form.jenis_kepindahan                  = ''
              this.form.status_kk_bagi_yang_tidak_pindah  = ''
              this.form.status_kk_bagi_yang_pindah        = ''
              this.form.shdk                              = ''
              this.form.shdk_lainnya                      = ''
              this.form.file_Kabupaten                    = ''
              this.form.file_Old_Kabupaten                = ''
              this.form.status                            = ''
              this.form.keterangan                        = ''
              this.form.keterangan_deskel                 = ''
              this.form.keterangan_kecamatan              = ''
              this.form.keterangan_kabupaten              = ''
              this.form.status_deskel                     = ''
              this.form.status_kecamatan                  = ''
              this.form.status_kabupaten                  = ''
              this.form.createdBy                         = ''
              this.form.createdAt                         = ''
              this.form.createdAt_deskel                  = ''
              this.form.createdAt_kecamatan               = ''
              this.form.createdAt_kabupaten               = ''
              this.form.file_terbitan                     = ''
              this.form.emailPemohon                      = ''
              this.form.email_file                        = ''
              this.form.email_fileOld                     = ''
              this.form.email_from                        = ''
              this.form.email_to                          = ''
              this.form.email_subject                     = ''
              this.form.email_html                        = '' 
              this.form.file_lampiran                     = null 
              this.form.file_lampiranOld                  = null
      },
      
      // ============================= KECAMATAN =============================
        getViewKecamatan : function(){
          // this.$store.commit("shoWLoading");
          fetch(this.$store.state.url.URL_PERMOHONAN_PPD3 + "viewKecamatan", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  data_ke           : this.page_first,
                  page_limit        : this.page_limit,
                  cari_value        : this.cari_value,
                  status_kecamatan  : this.form.status_kecamatan,
                  pl_provinsi       : this.$store.state.lcProfile.provinsi,
                  pl_kabupaten      : this.$store.state.lcProfile.kabupaten,
                  pl_kecamatan      : this.$store.state.lcProfile.kecamatan,
              })
            })
              .then(res => res.json())
              .then(res_data => { 
                  this.list_data_kecamatan = res_data.data;
                  this.page_last = res_data.jmlData; 
                  // console.log("INI KECAMATAN")
                  console.log(res_data);
          });
        }, 

        editDataKecamatan : function(status){
          this.$store.state.modal_loading = true;

          // console.log(status)
          fetch(this.$store.state.url.URL_PERMOHONAN_PPD3 + "editDataKecamatan", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                id : this.form.id,
                keterangan_kecamatan : this.form.keterangan_kecamatan,
                createdAt_kecamatan : UMUM.NOW(),
                kategorix : status
              })
          }).then(res_data => {
          this.$store.state.modal_loading = false;

              this.$store.commit('notif_edit');
              this.getViewKecamatan();
          });
        },

      // ============================= KECAMATAN =============================

      // ============================= KABUPATEN =============================
        getViewKabupaten : function(){
          
          // this.$store.commit("shoWLoading");
          fetch(this.$store.state.url.URL_PERMOHONAN_PPD3 + "viewKabupaten", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  data_ke: this.page_first,
                  page_limit : this.page_limit,
                  cari_value: this.cari_value,
                  status_kabupaten : this.form.status_kabupaten
              })
            })
              .then(res => res.json())
              .then(res_data => {
                // console.log("TAAAAAAAAAAIIIIIIII")
                  this.list_data_kabupaten = res_data.data;
                  this.page_last = res_data.jmlData;
                  // this.$store.commit("hideLoading");
                  console.log(res_data);
          });
        }, 
        editDataKabupaten : function(status){
          this.$store.state.modal_loading = true;

          console.log("SA DI CLICK")
          fetch(this.$store.state.url.URL_PERMOHONAN_PPD3 + "editDataKabupaten", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                id : this.form.id,
                keterangan_kabupaten : this.form.keterangan_kabupaten,
                createdAt_kabupaten : UMUM.NOW(),
                kategorix : status
              })
          }).then(res_data => {
          this.$store.state.modal_loading = false;

              this.$store.commit('notif_edit');
              this.getViewKabupaten();
          });
        }, 
        terbit_file_Kabupaten : function(){
          this.$store.state.modal_loading = true;

          console.log(this.form.email_fileOld);
          var formData = new FormData();
          formData.append("id", this.form.id);
          formData.append("email_file", this.form.email_file); 
          formData.append("email_fileOld", this.form.email_fileOld); 
          formData.append("email_from", this.form.email_from)
          formData.append("email_to", this.form.email_to)
          formData.append("email_subject", this.form.email_subject) 
          formData.append("email_html", this.form.email_html)
          
          fetch(this.$store.state.url.URL_PERMOHONAN_PPD3 + "file_terbitan_Kabupaten", {
              method: "POST",
              headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: formData,
          }).then(res_data => { 
              this.wa_notif()
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_terbit');
              this.getView();
          });
        },
        async wa_notif(){
          var data = await this.FETCHING.fetch_postx(this.$store.state.url.URL_WA_API+'send_wa' , JSON.stringify({
            createdBy : this.form.createdBy,
            pesan     : 'Permohonan Pindah Dalam Satu Desa/Kelurahan'
          }))
          console.log(data);
        },
        
      // ============================= KABUPATEN =============================
      bukaTab(linknya){
        window.open(linknya);
      },
    // ====================================== filter autocomplete  
      renderChildProv(data) {
          return `
          <span><b>${data.kd_provinsi}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },
      renderChildKab(data) {
          return `
          <span><b>${data.kd_kabupaten}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },
      renderChildKec(data) {
          return `
          <span><b>${data.kd_kecamatan}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    
      renderChild_des_kel(data) {
          return `
          <span><b>${data.kd_desa_kelurahan}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },

      get_auto(data){
        this.form.m_provinsi = data.m_provinsi
      },        
      get_auto_kab(data){ 
        this.form.m_kabupaten = data.m_kabupaten
      },        
      get_auto_kec(data){ 
        this.form.m_kecamatan = data.m_kecamatan
      },        
      get_auto_des_kel(data){
        this.form.m_desa_kelurahan = data.m_desa_kelurahan
      },  

 
      get_prov_pemohon(data){ 
        this.form.provinsi = data.m_provinsi   
      },
      get_kab_pemohon(data){ 
        this.form.kabupaten = data.m_kabupaten   
      },
      get_kec_pemohon(data){ 
        this.form.kecamatan = data.m_kecamatan   
      },
      get_deskel_pemohon(data){ 
        this.form.desa_kelurahan = data.m_desa_kelurahan   
      },

        get_prov_tujuan(data){ 
          this.form.provinsi_tujuan = data.m_provinsi   
        },        
        get_kab_tujuan(data){ 
          this.form.kabupaten_tujuan = data.m_kabupaten   
        },        
        get_kec_tujuan(data){ 
          this.form.kecamatan_tujuan = data.m_kecamatan   
        },        
        get_deskel_tujuan(data){ 
          this.form.desa_kelurahan_tujuan = data.m_desa_kelurahan   
        },        

 

    // ====================================== filter autocomplete 

      CariData(){
        
        if (this.$store.state.lcProfile.kelas == 'kecamatan') {
          this.getViewKecamatan()
        } else if (this.$store.state.lcProfile.kelas == 'kabupaten') {
          this.getViewKabupaten() 
        }else{
          this.getView();
        } 
      },
      cekButton_status_kecamatan: function(data){  
          var a = data.PPD3.status 
          var status_kab = data.PPD3.status_kabupaten  
          if (this.$store.state.lcProfile.kelas == 'op_vertikal') {
            if (status_kab == 1) {
              return true
            }
            return false
          }else{
            if (a == 1) {
              return true
            }else{
              return false
            }
          }  
        },
          

    },
    mounted(){
      this.MASTER_MENU.shdk();
      this.CariData()
      this.getView()

      this.$store.state.lcProfile.kelas
      this.$store.state.lcProfile.id
      var email_from          = this.$store.state.lcProfile.email 
      var email_pemohon       = this.$store.state.lcProfile.email 
      this.form.emailPemohon  = email_pemohon
      this.form.email_from    = email_from 
      
    }
}
